import React from 'react';
import ReactFitText from 'react-fittext';
import { Spring, config } from 'react-spring';
import styles from './hero-message.module.css';

const HeroMessage = ({ message }) => {
  return (
    <Spring
      from={{ opacity: 0, transform: 'translateY(20px)' }}
      to={{ opacity: 1, transform: 'translateY(0)' }}
      delay={800}
      config={{ tension: 180, friction: 60 }}
    >
      {animation => (
        <div style={animation}>
          <ReactFitText compressor={3.4} minFontSize={16} maxFontSize={22}>
            <h4
              className={styles.copy}
              dangerouslySetInnerHTML={{ __html: message }}
            />
          </ReactFitText>
        </div>
      )}
    </Spring>
  );
};

export default HeroMessage;



// WEBPACK FOOTER //
// ./src/components/hero/hero-message/index.js